"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterPage = void 0;
/* Package Imports */
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_toastify_1 = require("react-toastify");
/* Blast Imports */
var RegistrationForm_1 = __importDefault(require("../components/RegistrationForm"));
var actions_1 = require("../state/actions");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var LoadingIndicator_1 = require("@app/components/LoadingIndicator");
var ContainerPanel_1 = require("@app/components/layout/ContainerPanel");
var SplitPage_1 = require("@app/components/layout/SplitPage");
var PackagesApi = __importStar(require("@app/services/api/packages"));
var UsersApi = __importStar(require("@app/services/api/users"));
var utils_1 = require("@app/shared/utils");
var initialState = {
    alreadyRegistered: false,
    packageId: '',
    validatingEmail: true
};
/**
 * Blast's User Registration page component
 */
var RegisterPage = /** @class */ (function (_super) {
    __extends(RegisterPage, _super);
    function RegisterPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.handleRegister = function (email, context, firstName, lastName, company, password, passwordConfirmed, title, location) {
            _this.props.onRegister({
                email: email,
                firstName: firstName,
                lastName: lastName,
                company: company,
                title: title,
                location: location,
                context: context,
                password: password,
                passwordConfirmed: passwordConfirmed,
                redirectPackageId: _this.state.packageId
            });
        };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    RegisterPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var email, context, validated, validateDeliveryResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = this.props.match.params.email;
                        context = query_string_1.default.parse(this.props.location.search).context;
                        return [4 /*yield*/, UsersApi.checkRegistration(email)];
                    case 1:
                        validated = _a.sent();
                        return [4 /*yield*/, PackagesApi.validateDelivery(context)];
                    case 2:
                        validateDeliveryResponse = _a.sent();
                        this.setState(__assign(__assign({}, this.state), { alreadyRegistered: validated, packageId: validateDeliveryResponse.id, validatingEmail: false }));
                        return [2 /*return*/];
                }
            });
        });
    };
    RegisterPage.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.registrationError && this.props.registrationError !== prevProps.registrationError) {
            react_toastify_1.toast.error(this.props.registrationError);
        }
    };
    /* Component Methods - end */
    RegisterPage.prototype.render = function () {
        // Component variables
        var redirectParam = !!this.state.packageId ? "?redirectTo=/dash/packages/" + this.state.packageId : "";
        var email = this.props.match.params.email;
        var context;
        if (this.state.validatingEmail) {
            return react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, null);
        }
        if (!email) {
            return react_1.default.createElement(react_router_1.Redirect, { to: "/login" });
        }
        // Precautionary check, in case the query parameter is accidentally included in the "email"
        if (email.includes('?')) {
            // If "email" value includes query parameters, then split them and update "email" and "context"
            var split = email.split('?');
            email = split[0];
            context = query_string_1.default.parse(split[1]).context;
        }
        else {
            context = query_string_1.default.parse(this.props.location.search).context;
        }
        if (!context) {
            return react_1.default.createElement(react_router_1.Redirect, { to: "/login" });
        }
        if (this.state.alreadyRegistered) {
            return react_1.default.createElement(react_router_1.Redirect, { to: { pathname: '/login', search: redirectParam } });
        }
        /* Define elements used - begin */
        var registrationContent = utils_1.isInternalEmail(email) ?
            react_1.default.createElement("div", { className: "has-text-centered" },
                react_1.default.createElement("p", null, "Looks like you are a Hasbro employee."),
                react_1.default.createElement("p", null, "Click the button below to return to the login page and login using your Hasbro credentials"),
                react_1.default.createElement(react_router_dom_1.Link, { to: { pathname: '/login', search: redirectParam } },
                    react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-large button-centered" }, "Return to Login")))
            :
                react_1.default.createElement(RegistrationForm_1.default, { context: context, email: email, onRegister: this.handleRegister });
        /* Define elements used - end */
        return (react_1.default.createElement(SplitPage_1.SplitPage, { title: "Register" },
            react_1.default.createElement(ContainerPanel_1.ContainerPanel, { isLoading: this.props.isRegistering, title: "User registration for " + email, titleClassName: 'registration-title' }, registrationContent)));
    };
    return RegisterPage;
}(react_1.Component));
exports.RegisterPage = RegisterPage;
var mapStateToProps = function (state) {
    return {
        isRegistering: state.registration.isRegistering,
        registrationError: state.registration.registrationError
    };
};
var mapDispatchToProps = {
    onRegister: actions_1.register
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RegisterPage);
